/**
 * PageLoader - Loading spinner shown while lazy-loading pages
 * Provides a smooth loading experience during route transitions
 */
const PageLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="relative">
          <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 border-t-brand-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-b-brand-400 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1s' }}></div>
        </div>

        {/* Loading Text */}
        <div className="text-center">
          <p className="text-lg font-medium text-gray-700 dark:text-gray-300 animate-pulse">
            Loading...
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Please wait a moment
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
